var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin"},[_c('Header'),_c('div',{staticClass:"content"},[_c('router-view')],1),(_vm.env != 'prod')?_c('div',{staticClass:"teste"},[_vm._v("PORTAL TESTE")]):_vm._e(),_c('Status')],1)}
var staticRenderFns = []

export { render, staticRenderFns }